import {useState, useEffect} from 'react';

export const useDelayMount = (delay = 0) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const delayedMount = setTimeout(() => {
      setMounted(true);
    }, delay);
    return () => clearTimeout(delayedMount);
  }, [delay]);

  return mounted;
};
